/** 用来处理Js对象转换到Json时循环引用的问题 */
import { get } from "lodash-es";
/** 用来标注当前key为对象且引用了其他Json中的Object */
export const REF_SIGN = 'obj@';
/** 递归的最大深度 */
export const MAX_DEEP = 40;
const MAX_LENGTH_WARN = '[circleJson]mock数据源中出现了超长path';
/** 解除对象的循环引用并保存循环引用状态 深拷贝*/
export const circleStringify = (json, deep = 0, path = [], weakMap = new WeakMap()) => {
  if (deep > MAX_DEEP) {
    console.warn(MAX_LENGTH_WARN, path.join('.'));
    return undefined;
  }
  const newObj = json instanceof Array ? [] : {};
  if (json instanceof Object) {
    if (weakMap.has(json)) {
      // 要注入被循环引用的路径
      return `${REF_SIGN}${weakMap.get(json)}`;
    }
    weakMap.set(json, path.join('.'));
    // 要拿到数据源原型链上的key 只能用for in
    // eslint-disable-next-line no-restricted-syntax
    for (const key in json) {
      const value = json[key];
      path.push(key);
      const newVal = circleStringify(value, deep + 1, path, weakMap);
      if (newVal !== undefined) newObj[key] = newVal;
      path.pop();
    }
    return newObj;
  }
  if (typeof json === 'function') {
    return undefined;
  }
  return json;
};
/** 从特殊的JSON对象 链接循环引用 */
export const circleParse = json => circleParseImpl(json, json);
const circleParseImpl = (json, originObj, deep = 0, path = []) => {
  if (!(json instanceof Object)) return json;
  const newObj = Array.isArray(json) ? [] : {};
  Object.entries(json).forEach(([key, value]) => {
    if (typeof value === 'string' && value.substring(0, 4) === REF_SIGN) {
      const [, valuePath] = value.split(REF_SIGN);
      return newObj[key] = get(originObj, valuePath);
    }
    path.push(key);
    newObj[key] = circleParseImpl(value, originObj, deep + 1, path);
    path.pop();
  });
  return newObj;
};
//# sourceMappingURL=circleJson.js.map
